// Links de rota para o endereço do vínculo (texto livre), abertos no app/site de mapas.
export function directionsLinks(endereco) {
  const query = encodeURIComponent(endereco.trim());
  return {
    googleMaps: `https://www.google.com/maps/search/?api=1&query=${query}`,
    waze: `https://waze.com/ul?q=${query}&navigate=yes`,
  };
}
